// extracted by mini-css-extract-plugin
export default {"noBackground":"yaa-z","qnaContainer":"zaa-z","qna":"Aaa-z","question":"Baa-z","modal":"Caa-z"};